/**
 * Drop the router state carried on the current history entry, once it has been acted on.
 *
 * navigate(path, { state }) stores that state on the history entry itself, and the
 * browser replays history.state verbatim after a full page reload. React Router rebuilds
 * location.state from `window.history.state.usr` on boot, so a refresh hands the
 * consuming effect the very same payload again. For the conversation view that means
 * re-sending a message the agent has already answered - and because the send is
 * fire-and-forget with no idempotency on the server, every replay is a full duplicate
 * agent run.
 *
 * Only `usr` is cleared. React Router keeps its own `idx` and `key` on the same object
 * and derives back/forward deltas from `idx`, computing the next one as `getIndex() + 1`;
 * replacing the whole state with `{}` would drop `idx` and make that arithmetic NaN.
 */
export const clearRouterState = (): void => {
    const { state } = window.history;
    window.history.replaceState({ ...state, usr: null }, "");
};
